import {Space} from 'antd'
import styles from './ListPanel.module.scss'
import {Search} from 'common/components'
import {maybePluralize} from 'common/helpers'
import { OrgType } from '../types'
interface ListPanelProps {
  counterType: OrgType;
  count: number;
  search: string;
  sort: string;
  setSearch: (search: string) => void;
  setSort: (sort: string) => void;
}

// const sortItems = [
//   {label: 'Name', key: 'firstName'},
//   {label: 'Date of registration', key: 'createdAt'},
// ]
export const ListPanel:React.FC<ListPanelProps> = ({
  counterType,
  count, search, setSearch, // sort, setSort,
}) => {
  // const sortItem = sortItems.find((item) => item.key === sort)

  return (
    <div className={styles.root}>
      <Space>
        <h2 className={styles.title}>
          {maybePluralize(count, counterType )}
        </h2>
        <Search
          search={search}
          placeholder="name, email, phone number etc."
          setSearch={setSearch}
        />
      </Space>
      {/* <Sort alignRightDropdown sort={sort} items={sortItems} setSort={setSort}>
        <Button dropdown variant="text">
          <Space>
            <SortIcon />
            <span>
              Sort by: <span className={styles.value}>{sortItem.label}</span>
            </span>
          </Space>
        </Button>
      </Sort> */}
    </div>
  )
}
